import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  AllocationSheetsServiceProxy,
  AllocationSheetStatus,
  GetLocationForViewDto,
  LocationsServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { Subject, ReplaySubject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-allocation-filters-bar',
  templateUrl: './allocation-filters-bar.component.html',
  styleUrls: ['./allocation-filters-bar.component.css'],
})
export class AllocationFiltersBarComponent
  extends AppComponentBase
  implements OnInit {
  @Output() onFiltersChange: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('creatorSelector', { static: true }) creatorSelector: MatSelect;
  @ViewChild('signOffSelector', { static: true })
  signOffSelector: MatSelect;
  @ViewChild('locationSelector', { static: true })
  locationSelector: MatSelect;

  protected _onDestroy = new Subject<void>();

  public rangeFormGroup: FormGroup = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  public creatorFormCtrl: FormControl = new FormControl();
  public creatorFilterFormCtrl: FormControl = new FormControl();
  public filteredCreator: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  public signOffFormCtrl: FormControl = new FormControl();
  public signOffFilterFormCtrl: FormControl = new FormControl();
  public filteredSignOff: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  public locationFormCtrl: FormControl = new FormControl();
  public locationFilterFormCtrl: FormControl = new FormControl();
  public filteredLocation: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  creatorsAndSignOffs;
  locations;
  allocationStatuses;

  statusFilter = 0;

  constructor(
    injector: Injector,
    private _allocationSheetsServiceProxy: AllocationSheetsServiceProxy,
    private _locationsServiceProxy: LocationsServiceProxy,
    private cdr: ChangeDetectorRef,
    private _projectService:ProjectService
  ) {
    super(injector);
  }

  async ngOnInit() {
    let keyValueArray = Object.keys(AllocationSheetStatus).map((k) => ({
      value: k,
      key: AllocationSheetStatus[k as any],
    }));
    keyValueArray = keyValueArray.slice(0, keyValueArray.length / 2);
    this.allocationStatuses = keyValueArray;

    const editData = forkJoin({
      creatorsAndSignOffs: this._allocationSheetsServiceProxy.getAllStaffForLookupTable(
        null,
        null,
        0,
        999999
      ),
      locations: this._locationsServiceProxy.getAll(
        null,        
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        0,
        999999
      ),
    });
    editData.subscribe((data) => {
      this.filteredCreator.next(data.creatorsAndSignOffs.items.slice());
      this.filteredSignOff.next(data.creatorsAndSignOffs.items.slice());
      this.filteredLocation.next(data.locations.items.slice());

      this.creatorsAndSignOffs = data.creatorsAndSignOffs.items;
      this.locations = data.locations.items;
    });

    this.creatorFilterFormCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCreator();
      });

    this.signOffFilterFormCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterSignOff();
      });

    this.locationFilterFormCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterLocation();
      });
  }

  datapickerClose() {
    this.filtersChange();
  }

  setStatusFilter(status) {
    this.statusFilter = status;
    this.filtersChange();
  }

  refresh() {
    this.filtersChange();
  }

  filtersChange() {
    const params = {
      startDate: this.rangeFormGroup.get('start').value || null,
      endDate: this.rangeFormGroup.get('end').value || null,
      creator: this.creatorFormCtrl.value || null,
      signOff: this.signOffFormCtrl.value || null,
      locations: this.locationFormCtrl.value || null,
      status: this.statusFilter || null,
    };

    this.onFiltersChange.emit(params);
  }

  clearFilters(): void {
    this.rangeFormGroup.get('start').setValue(null);
    this.rangeFormGroup.get('end').setValue(null);
    this.creatorFormCtrl.setValue(null);
    this.signOffFormCtrl.setValue(null);
    this.locationFormCtrl.setValue(null);
    this.statusFilter = null;

    this.filtersChange();
  }

  protected filterCreator() {
    if (!this.creatorsAndSignOffs) {
      return;
    }

    let search = this.creatorFilterFormCtrl.value;
    if (!search) {
      this.filteredCreator.next(this.creatorsAndSignOffs.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredCreator.next(
      this.creatorsAndSignOffs?.filter(
        (creator) => creator.displayName.toLowerCase().indexOf(search) > -1
      )
    );
  }

  protected filterSignOff() {
    if (!this.creatorsAndSignOffs) {
      return;
    }

    let search = this.signOffFilterFormCtrl.value;
    if (!search) {
      this.filteredSignOff.next(this.creatorsAndSignOffs.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredSignOff.next(
      this.creatorsAndSignOffs?.filter(
        (signOff) => signOff.displayName.toLowerCase().indexOf(search) > -1
      )
    );
  }

  protected filterLocation() {
    if (!this.locations) {
      return;
    }

    let search = this.locationFilterFormCtrl.value;
    if (!search) {
      this.filteredLocation.next(this.locations.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredLocation.next(
      this.locations?.filter(
        (location: GetLocationForViewDto) =>
          location.location.name.toLowerCase().indexOf(search) > -1
      )
    );
  }
}
